import { contactGetDescription as description } from './description';
import { getContact as execute } from './execute';

export { description, execute };
